import React from "react";
import {
  Dialog, DialogTitle, DialogContent,
  Button, Box, Typography
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";

const ExportFormatModal = ({ open, onClose, onSelectPDF, onSelectExcel }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography fontWeight={600}>Choose Export Format</Typography>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" gap={2} justifyContent="center" py={1}>
          <Button
            variant="contained"
            color="error"
            startIcon={<PictureAsPdfIcon />}
            onClick={() => { onSelectPDF(); onClose(); }}
          >
            PDF
          </Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<TableChartIcon />}
            onClick={() => { onSelectExcel(); onClose(); }}
          >
            Excel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ExportFormatModal;